export default function formatAssetUrl (url) {
    return process.env.REACT_APP_PAGE_DOMAIN ? (url || "").replace("//a.storyblok.com", `//content.${process.env.REACT_APP_PAGE_DOMAIN}`) : url;
  }